import { Link as InnerLink } from 'react-router-dom';
import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { BodyCopy, Headline } from '@xing-com/typography';

import { CompanyCard as InnerCompanyCard } from '../../components/company-card';

export const TickListItem = styled.div`
  display: flex;
`;

export const TickListItemContent = styled(BodyCopy)`
  padding-left: var(--spaceS);
  @media (min-width: 740px) {
    max-width: 80%;
  }
  @media (min-width: 1024px) {
    max-width: 60%;
  }
`;

export const ErrorPageWrapper = styled.div`
  width: 100%;
`;

export const InfoWrapper = styled(BodyCopy)`
  text-align: justify;
`;

export const TickListItemsWrapper = styled.div`
  margin-top: var(--spaceXL);
`;

export const Header = styled.header`
  margin-bottom: var(--spaceS);
  @media (min-width: 740px) {
    margin-bottom: var(--spaceXXL);
  }
`;

export const CompaniesRow = styled.section`
  margin: var(--spaceXL) var(--spaceS);
  max-width: 100%;
  width: 100%;
`;

export const CompaniesTitle = styled(Headline)`
  margin-left: calc(-1 * var(--spaceS));
`;

export const CompaniesContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin-left: calc(-1 * var(--spaceL));
  margin-right: calc(-1 * var(--spaceL));
`;

export const IndustryLink = styled(InnerLink)`
  display: flex;
  flex-direction: column;
  padding: var(--spaceL) var(--spaceS);
  color: var(--xdlColorText);
  text-decoration: none;
  width: 100%;
  display: flex;
  max-width: 50%;
  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  @media (min-width: 740px) {
    width: 100%;
    display: flex;
    max-width: 25%;
  }

  @media (min-width: 1024px) {
    width: 100%;
    display: flex;
    max-width: 20%;
  }
`;

export const IndustriesShowAllWrapper = styled.div`
  flex: 1;
  text-align: left;

  &:hover {
    text-decoration: underline;
    cursor: pointer;
  }

  @media (min-width: 1259px) {
    margin-right: var(--spaceS);
    margin-left: var(--spaceS);
    padding: var(--spaceL);
  }
`;

export const IndustriesButton = styled(Button)`
  padding-left: var(--spaceS);
  @media (min-width: 1259px) {
    padding-left: var(--spaceL);
  }
`;

export const Wrapper = styled.div`
  width: 100%;
  display: flex;
  max-width: 50%;
  margin-bottom: var(--spaceL);
  padding-right: var(--spaceS);
  padding-left: var(--spaceS);
  @media (min-width: 740px) {
    max-width: calc(100% / 3);
  }
  @media (min-width: 1259px) {
    flex: 1;
    max-width: 20%;
    &:nth-child(5n) {
      display: none;
    }
    margin-bottom: 0;
  }
`;

export const CompanyCard = styled(InnerCompanyCard)`
  min-width: 100%;
  display: flex;
`;

export const ViewMoreWrapper = styled.div`
  width: 100%;
  max-width: 50%;
  display: flex;
  margin-bottom: var(--spaceL);
  padding-right: var(--spaceS);
  padding-left: var(--spaceS);
  @media (min-width: 740px) {
    max-width: calc(100% / 3);
  }
  @media (min-width: 1259px) {
    flex: 1;
    max-width: 100%;
    margin-bottom: 0;
  }
`;

export const ViewMoreInner = styled.div`
  border: 2px solid var(--xdlColorBorderSoft);
  border-radius: var(--spaceS);
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  display: flex;
  width: 100%;
  padding: var(--spaceL);
`;

export const ViewMoreLink = styled(InnerLink)`
  display: flex;
  color: var(--xdlColorText);
  line-height: var(--spaceM);
`;

export const ViewMoreCaption = styled(BodyCopy)`
  margin-bottom: var(--spaceS);
  text-align: left;
  @media (min-width: 1259px) {
    margin-bottom: var(--spaceXXL);
  }
`;

export const ViewMoreCaptionHighlight = styled.span`
  position: relative;
  z-index: 2;
  text-align: left;
  display: inline-block;
  &:after {
    z-index: -1;
    content: '';
    display: block;
    position: absolute;
    left: 50%;
    bottom: 0;
    width: 100%;
    transform: translateX(-50%);
    height: 50%;
    background-color: var(--xdlColorXING);
  }
`;
